import { Box, Button, Chip, Divider, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "tss-react/mui";
import { Circle as CircleIcon, Check as CheckIcon } from "@mui/icons-material";
import { useMemo, useState } from "react";
import { TaskEnumsLists } from "../../../../common/constants";
import { GetEstimatedUrgencyColor } from "../../../../common/mission";
import moment from "moment/moment";

const useStyles = makeStyles()(
  (theme) => ({
    root: {
      position: "relative",
      background: theme.palette.background.default,
      padding: `${theme.spacing(2)} ${theme.spacing(1.5)}`,
      borderRadius: theme.spacing(2)
    },
    urgencyButtonBox: {
      background: theme.palette.background.grey,
      borderRadius: theme.spacing(1),
      padding: "4px"
    },
    button: {
      marginLeft: theme.spacing(0.25),
      marginRight: theme.spacing(0.25),
      paddingLeft: "4px",
      paddingRight: "4px",
      minWidth: "48px",
      height: "40px",
      borderRadius: "6px !important",
      transition: "background 250ms"
    },
    activeButton: {
      background: theme.palette.background.default,
      fontWeight: 600
    },
    inActiveButton: {
      color: theme.palette.text.secondary,
    },
    slimSpan: {
      fontWeight: 400
    },
    planningFilter: {
      width: "200px"
    }
  })
);


export default function UrgencyToolbar(props) {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const [urgencyFilter, setUrgencyFilter] = useState(null);
  const [planningFilter, setPlanningFilter] = useState(-1);
  const [lowPriorityFilter, setLowPriorityFilter] = useState(true);
  const [normalPriorityFilter, setNormalPriorityFilter] = useState(true);
  const [highPriorityFilter, setHighPriorityFilter] = useState(true);

  const { planningFilters } = useMemo(() => {

    const now = moment();

    const planningFilters = [
      {
        label: t("common:filters:planning:none"),
        arrival: now.clone(),
      },
      {
        label: t("common:filters:planning:next2hours"),
        arrival: now.clone(),
      },
      {
        label: t("common:filters:planning:next5hours"),
        arrival: now.clone(),
      },
      {
        label: t("common:filters:planning:today"),
        arrival: now.clone(),
      },
      {
        label: t("common:filters:planning:next24hours"),
        arrival: now.clone(),
      },
      {
        label: t("common:filters:planning:thisWeek"),
        arrival: now.clone(),
      },
    ];

    return {
      planningFilters
    }
  }, [t]);


  return (
    <Box className={classes.root}>
      <Stack direction="row" spacing={1.5}>

        <Box className={classes.urgencyButtonBox}>
          <Stack direction="row" spacing={0.5}>

            <Button className={`${classes.button} ${urgencyFilter === null ? classes.activeButton : classes.inActiveButton}`} onClick={() => setUrgencyFilter(null)}>
              <span className={classes.slimSpan}>{t("common:all")}</span>&nbsp;6
            </Button>

            {TaskEnumsLists.EstimatedUrgency.map((u, val) => <UrgencyButton key={val} onClick={setUrgencyFilter} urgency={val} urgencyFilter={urgencyFilter} count={3} />).reverse()}

          </Stack>
        </Box>

        <Divider orientation="vertical" sx={{ height: "48px" }} />

        <FormControl fullWidth size="small" variant="filled" className={classes.planningFilter}>
          <InputLabel>{t("mission:cards:tasks:planning:label")}</InputLabel>
          <Select onChange={ev => setPlanningFilter(ev.target.value)} value={planningFilter}>
            <MenuItem value={-1}>{t("common:all")}</MenuItem>
            <Divider />
            {planningFilters.map((filter, value) => <MenuItem value={value} key={value}>{filter.label}</MenuItem>)}
          </Select>
        </FormControl>

        <Divider orientation="vertical" sx={{ height: "48px" }} />

        <Stack spacing={0.5}>
          <Typography variant="caption" color="textSecondary">{t("task:urgency:priority")}:</Typography>
          <Stack direction="row" spacing={0.5}>
            <Chip
              size="small"
              label={t("task:enums:priority:High")}
              onClick={() => setHighPriorityFilter(v => !v)}
              variant={highPriorityFilter ? "filled" : "outlined"}
              icon={highPriorityFilter ? <CheckIcon /> : undefined}
            />
            <Chip
              size="small"
              label={t("task:enums:priority:Normal")}
              onClick={() => setNormalPriorityFilter(v => !v)}
              variant={normalPriorityFilter ? "filled" : "outlined"}
              icon={normalPriorityFilter ? <CheckIcon /> : undefined}
            />
            <Chip
              size="small"
              label={t("task:enums:priority:Low")}
              onClick={() => setLowPriorityFilter(v => !v)}
              variant={lowPriorityFilter ? "filled" : "outlined"}
              icon={lowPriorityFilter ? <CheckIcon /> : undefined}
            />

          </Stack>
        </Stack>


      </Stack>
    </Box>
  );
}

function UrgencyButton(props) {
  const { urgency, urgencyFilter, onClick, count } = props;
  const { classes } = useStyles();
  const color = GetEstimatedUrgencyColor(urgency);

  return (
    <Button
      className={`${classes.button} ${urgency === urgencyFilter ? classes.activeButton : classes.inActiveButton}`}
      startIcon={<CircleIcon sx={{ color }} />}
      onClick={() => onClick(urgency)}
      TouchRippleProps={{
        style: { color },
      }}
    >
      {count}
    </Button>
  );
}



